@if (valueOnly()) {
  <span class="text-lg">
    {{ yieldKwh() != null ? (yieldKwh()! | number:'1.0-1':'de') : '–' }}<span class="text-xs pl-2">kWh</span>
  </span>
} @else {
  <div class="wrap-break-word border-b border-gray-200 md:border-0 px-4 py-2 grid grid-cols-[1fr_auto] gap-1 items-baseline">
    <span class="text-sm pt-1">{{ label() }}</span>
    <span class="text-lg pt-1 text-right">
      {{ yieldKwh() != null ? (yieldKwh()! | number:'1.0-1':'de') : '–' }}<span class="text-xs pl-2">kWh</span>
    </span>
  </div>
}
